export default {
	reviewMethodsInfo:
		'Implemented measures need to be reviewed at least once a year. For {count} measures, a year has nearly passed since their last review. Check these measures by pressing the "View Measures" button. You can review each measure individually on the measures page or confirm all measures after review by clicking the "Confirm" button.',
	methodLastReviewed: 'Renew measure',
	viewMethods: 'Review measures',
	methodsReviewed: '{count} measures renewed.',
}
